import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import {
  IS_API_GATEWAY,
  IS_PRIVATE_API,
} from '@personal-area/global/http/models';
import {
  BillingAddress,
  ConfirmationMethod,
  LastDepositsResponse,
  User,
  UserSettings,
  userURLs,
} from '@personal-area/global/users/models';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private _http = inject(HttpClient);

  /**
   * Fetch user from API (User Service).
   * @returns {Observable<User>} Observable object with user
   */
  public fetchUser(userID: number, withExtras = false): Observable<User> {
    return this._http.get<User>(userURLs.fetch(userID, withExtras), {
      context: new HttpContext().set(IS_PRIVATE_API, true),
    });
  }

  public updateAddress(userId: number, data: BillingAddress): Observable<void> {
    return this._http.patch<void>(
      userURLs.base(userId),
      { billingAddress: data },
      {
        context: new HttpContext()
          .set(IS_PRIVATE_API, true)
          .set(IS_API_GATEWAY, true),
      },
    );
  }

  public updateSettings(userId: number, data: UserSettings): Observable<void> {
    return this._http.patch<void>(userURLs.base(userId), data, {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }

  public changeName(userId: number, name: string): Observable<void> {
    return this._http.patch<void>(
      userURLs.base(userId),
      { name },
      {
        context: new HttpContext()
          .set(IS_PRIVATE_API, true)
          .set(IS_API_GATEWAY, true),
      },
    );
  }

  public changeConfirmationMethod(
    userId: number,
    method: ConfirmationMethod,
  ): Observable<void> {
    return this._http.patch<void>(
      userURLs.base(userId),
      { ConfirmationMethod: method },
      {
        context: new HttpContext()
          .set(IS_PRIVATE_API, true)
          .set(IS_API_GATEWAY, true),
      },
    );
  }

  public lastDeposits(userId: number): Observable<LastDepositsResponse> {
    return this._http.get<LastDepositsResponse>(userURLs.lastDeposits(userId), {
      context: new HttpContext().set(IS_PRIVATE_API, true),
    });
  }
}
